import {takeEvery, call, put} from 'redux-saga/effects'
import {types} from './types'
import axios from '../../../../Axios'
import { Urls } from '../../../../Urls'
import {fetchDataFailure, fetchDataSuccess} from './actions'

function* asyncFetchRequest(action) {
    try{
        const response = yield call(() => axios.get(`${Urls.Transporters.Get}?transporter_id=${action.payload}`))
        sessionStorage.setItem('client_transporter_code', response.data.profile_code)
        yield put(fetchDataSuccess(response.data))
    } catch(error){
        yield put(fetchDataFailure(response.error))
    }
    
}


export default function* watchFetchDataSaga(){
    yield takeEvery(types.SEND_REQUEST, asyncFetchRequest)
}